import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Globe2 } from 'lucide-react';
import { Container, PageHeader } from '@vnetwork/ui/layout';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@vnetwork/ui/primitives';
import { ElasticIps } from './vpn/ElasticIpTab';
import { GatewaysTab } from './vpn/GatewaysTab';
import { IkeTab, IpsecTab } from './vpn/PolicyTabs';
import { S2sTab } from './vpn/S2sTab';
import { SnatTab } from './vpn/SnatTab';

type Tab = 'eip' | 'gateways' | 'ike' | 'ipsec' | 's2s' | 'snat';
const TABS: [Tab, string][] = [
  ['eip', 'Elastic IPs'],
  ['gateways', 'VPN gateways'],
  ['ike', 'IKE policies'],
  ['ipsec', 'IPSec policies'],
  ['s2s', 'S2S connections'],
  ['snat', 'Source NAT'],
];

export function VpnElasticIp() {
  const { serviceId } = useParams<{ serviceId: string }>();
  const [tab, setTab] = useState<Tab>('eip');
  const s = serviceId!;

  return (
    <Container size="xl">
      <PageHeader icon={<Globe2 size={22} />} title="Elastic IP & VPN" description="Floating public IPs and site-to-site VPN." />
      <Tabs value={tab} onValueChange={(v) => setTab(v as Tab)}>
        <TabsList style={{ flexWrap: 'wrap' }}>
          {TABS.map(([k, label]) => (
            <TabsTrigger key={k} value={k}>{label}</TabsTrigger>
          ))}
        </TabsList>
        <TabsContent value="eip"><ElasticIps serviceId={s} /></TabsContent>
        <TabsContent value="gateways"><GatewaysTab serviceId={s} /></TabsContent>
        <TabsContent value="ike"><IkeTab serviceId={s} /></TabsContent>
        <TabsContent value="ipsec"><IpsecTab serviceId={s} /></TabsContent>
        <TabsContent value="s2s"><S2sTab serviceId={s} /></TabsContent>
        <TabsContent value="snat"><SnatTab serviceId={s} /></TabsContent>
      </Tabs>
    </Container>
  );
}
